import React from "react"
import CheckBox, {CheckboxType} from "../../../../../gd-components/checkbox/checkbox"

type Props = {
    title           : string
    groupValues     : string[]
    selectedValues  : string[]
    isCollapsed     : boolean
    onGroupClick    : (values: string[]) => void
    onToggleCollapse: () => void
}

export default function PopoverGroupHeader(props: Props) {
    const allSelected = props.groupValues.length > 0
        && props.groupValues.every(v => props.selectedValues.includes(v))

    const onCheckboxClick = () => {
        props.onGroupClick(props.groupValues)
    }

    return (
        <div className="ui5-txt-default txt-semibold m-l-10 m-r-20 m-t-15 m-b-12 flex-row-left-center cursor-pointer"
             onClick={props.onToggleCollapse}
        >
            <div className={Classes("ui5-ico-12 m-r-6 flex-shrink-0", props.isCollapsed ? 'i5-angle-right' : 'i5-angle-down')}/>
            <CheckBox isChecked={allSelected} className="m-r-8 flex-shrink-0" onClick={onCheckboxClick} type={CheckboxType.FILLED} />
            <div className="name">{props.title}</div>

        </div>
    )
}
